import {
  IAlignmentResult,
  IAlignmentResultGroup,
  IAlignmentResultModule,
  IAlignmentResultSection,
  IDraggableAlignmentResult,
  IDraggableAlignmentResultSection,
  IResource,
  ISectionGroup,
  IUpdateSubject,
  SectionGroup,
} from "store/types";
import { excludeAll } from "./dragDropUtils";

export const mapFromDraggable = (subjectId: number, templateId: number, result: IDraggableAlignmentResult) => {
  // If we still have content in unsorted, move it all to exclude
  const unsorted = result.sectionGroups.find(
    (sectionGroup: ISectionGroup) => sectionGroup.name === SectionGroup.UNSORTED,
  );
  if (unsorted) {
    unsorted.sections.forEach((section: IDraggableAlignmentResultSection) => {
      const source = { droppableId: section.uid, index: 0 };
      const draggableIds = section.resourceIds;
      result = excludeAll(source, draggableIds, result);
    });
  }

  return {
    siteId: subjectId,
    templateId,
    groups: result.sectionGroups.map((sectionGroup: ISectionGroup) => {
      return {
        name: sectionGroup.name,
        sections: sectionGroup.sections.map((section: IDraggableAlignmentResultSection) => {
          return {
            uid: section.uid,
            id: section.id,
            name: section.name,
            visible: section.visible,
            userVisible: section.userVisible,
            section: section.section,
            content: section.content,
            contentFormat: section.contentFormat,
            modules: section.resourceIds.map((uid: string) => {
              const resource = result.resources.find((resource: IResource) => resource.uid === uid);
              if (resource) {
                return {
                  uid: resource.uid,
                  id: resource.id,
                  name: resource.description,
                  type: resource.type,
                  content: [resource.content],
                  visible: resource.visible,
                  userVisible: resource.userVisible,
                  instance: resource.instance,
                  contextId: resource.contextId,
                  indent: resource.indent,
                  sectionId: resource.sectionId,
                  sectionUid: resource.sectionUid,
                  originalSectionId: resource.originalSectionId,
                  originalSectionUid: resource.originalSectionUid,
                  originalSectionName: resource.originalSectionName,
                  readOnly: resource.readOnly,
                  iconUrl: resource.iconUrl,
                  siteId: resource.siteId,
                };
              }
            }),
          };
        }),
      };
    }),
  } as IUpdateSubject;
};

export const mapToDraggable = (results: IAlignmentResult) => {
  const resources: any[] = [];
  return {
    sectionGroups: results.groups.map((result: IAlignmentResultGroup) => {
      return {
        name: result.name,
        sections: result.sections
          ? result.sections.map((section: IAlignmentResultSection) => {
              return {
                uid: section.uid,
                id: section.id,
                name: section.name,
                visible: section.visible,
                userVisible: section.visible,
                section: section.section,
                content: [],
                contentFormat: section.contentFormat,
                resourceIds: section.modules
                  ? section.modules.map((module: IAlignmentResultModule) => {
                      resources.push({
                        uid: module.uid,
                        id: module.id,
                        description: module.name,
                        type: module.type,
                        content: module.content[0],
                        visible: module.visible,
                        userVisible: module.userVisible,
                        instance: module.instance,
                        contextId: module.contextId,
                        indent: module.indent,
                        confidence: undefined, // TODO
                        sectionId: module.sectionId,
                        sectionUid: module.sectionUid,
                        originalSectionId: module.originalSectionId,
                        originalSectionUid: module.originalSectionUid,
                        originalSectionName: module.originalSectionName,
                        readOnly: module.readOnly,
                        iconUrl: module.iconUrl,
                        siteId: module.siteId,
                      });
                      return module.uid;
                    })
                  : [],
              };
            })
          : [],
      };
    }),
    resources,
  } as IDraggableAlignmentResult;
};
